/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import I18n from 'components/Translate/I18n';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import Alert from 'react-bootstrap-sweetalert';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import GridContainer from '../Grid/GridContainer';
import Button from '@material-ui/core/Button';
import { ReactComponent as Cancel } from '../../assets/themes/OPL/img/icons/Cancel.svg';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import GridItem from '../Grid/GridItem';
import MsisdnChooseNumberList from '../../views/msisdn-pools/Dialog/MsisdnChooseNumberList';
import { DialogActions } from '@material-ui/core';
import CustomTextButtom from '../Buttons/CustomTextButton';

class AlertInfo extends PureComponent {
    render() {
        const { onConfirm, onCancel, confirmBtnText, cancelBtnText, content, valueObject, show } = this.props;
        return (
            <Dialog fullWidth={true} maxWidth="sm" open={true}>
                <DialogTitle id="alert-dialog-slide-title">
                    <GridContainer justifyContent={'space-between'}>
                        <h4>
                            <I18n trans="general:common.operation_confirm" />
                        </h4>
                        <Button onClick={onCancel} color="primary">
                            <Cancel width={24} height={24} />
                        </Button>
                    </GridContainer>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="subtitle2">
                        <I18n trans={content} valueObject={valueObject} />
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <CustomTextButtom callback={onConfirm} callbackParam={{}} label={confirmBtnText} size="sm" />
                </DialogActions>
            </Dialog>
        );
    }
}

AlertInfo.propTypes = {
    classes: PropTypes.object.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    confirmBtnText: PropTypes.string.isRequired,
    cancelBtnText: PropTypes.string,
    content: PropTypes.string.isRequired,
    valueObject: PropTypes.object,
    show: PropTypes.bool,
};

export default withStyles(adescomStyle)(AlertInfo);
